export const ADVANCED_FILTER_OPEN_BUTTON_TEXT = "Filters";
export const ADVANCED_FILTER_HEADER_TEXT = "Filter data results";
export const ADVANCED_FILTER_APPLY_BUTTON_TEXT = "Apply";
export const ADVANCED_FILTER_CANCEL_BUTTON_TEXT = "Cancel";
export const ADVANCED_FILTER_CLEAR_BUTTON_TEXT = "Clear all";

export const ADVANCED_FILTER_OPEN_BUTTON_TEST_ID = "open-advanced-filter";
export const ADVANCED_FILTER_CLEAR_BUTTON_TEST_ID = "clear-advanced-filter";
